// extracted by mini-css-extract-plugin
export var grid = "search-input-module--grid--e3b3b";
export var gridWithRowGap = "search-input-module--grid--with-row-gap--269db";
export var maxWidthContainer = "search-input-module--max-width-container--9cf6e";
export var mt0 = "search-input-module--mt-0--d796b";
export var mt1 = "search-input-module--mt-1--ff958";
export var mt2 = "search-input-module--mt-2--86e3c";
export var mt3 = "search-input-module--mt-3--5acbc";
export var mt4 = "search-input-module--mt-4--a4cc4";
export var mt5 = "search-input-module--mt-5--e52c4";
export var mt6 = "search-input-module--mt-6--eb69e";
export var removeVisuallyHidden = "search-input-module--remove-visually-hidden--051cd";
export var searchInput__closeBtn = "search-input-module--search-input__close-btn--f0d6f";
export var searchInput__closeIcon = "search-input-module--search-input__close-icon--cdce2";
export var searchInput__input = "search-input-module--search-input__input--fd6b4";
export var searchInput__inputWrapper = "search-input-module--search-input__input-wrapper--e9d1b";
export var searchInput__searchBtn = "search-input-module--search-input__search-btn--bf9a1";
export var visuallyHidden = "search-input-module--visually-hidden--dd2d7";
export var widgetBase = "search-input-module--widget-base--46792";